import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import RadioPharmacyApi from "../../api/radiopharmacy_api";
import TableRadioPharmacy from "./TableRadioPharmacy";
import TableRadioPharmacyActions from "./TableRadioPharmacyActions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
const RadioPharmacy = ({ history, location }) => {

    const [radioParmachyList, setRadioPharmacyList] = useState([]);

    const listRadioPharmacy = async () => {
        let list = await RadioPharmacyApi.listAppointmentRadioPharmacy();
        if (list.existe == true && list.contenido.length > 0) {
            setRadioPharmacyList(list.contenido);
        }
    }

    const AllRadioPharmacy = () => {
        return (
            <Row>
                <Col md={12}>
                    <h6 className="page-title center-title">Lista de Citas</h6>
                </Col>
                <Col md={12}>
                    <TableRadioPharmacy title="Radio Farmacos" reactTableData={radioParmachyList} ReactTableActions={TableRadioPharmacyActions} />
                </Col>
            </Row>
        );
    }

    useEffect(() => {
        listRadioPharmacy();
    }, []);

    return (
        <Container>
            <Row>
                <Col md={12}>
                    {radioParmachyList.length > 0 && <AllRadioPharmacy />}
                </Col>
            </Row>

        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_radio_pharmacy',
})(RadioPharmacy);